import script from "./SerialSettingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SerialSettingsView.vue?vue&type=script&setup=true&lang=ts"

import "./SerialSettingsView.vue?vue&type=style&index=0&id=2f0cb6a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0cb6a7"]])

export default __exports__